import { createSelector } from 'reselect';

const icons = (store) => store.application.icons;

export const getIcons = createSelector(
	[ icons ],
	(icons) => (icons ? Object.entries(icons).map(([ key, value ]) => ({ id: value, name: key })) : [])
);